import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "../Homescreen/Homescreen.module.css";
import { db } from "../firebase-config";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";

function Clients() {
  const [clients, setClients] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const getClients = async () => {
      const clientsCollectionRef = collection(db, "clients");
      const data = await getDocs(clientsCollectionRef);
      setClients(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };

    getClients();
  }, []);

  const deleteClient = async (id) => {
    const clientDoc = doc(db, "clients", id);
    await deleteDoc(clientDoc);
    navigate("/home");
  };
  return (
    <div className={classes.mainscreen_display}>
      <div className={classes.details}>
        <div className={classes.details_info}>
          <h1>List of clients</h1>
          <table>
            <thead>
              <tr>
                <td>
                  <h3>Company name</h3>
                </td>
                <td>
                  <h3>Actions</h3>
                </td>
              </tr>
            </thead>

            {clients.map((client) => {
              return (
                <tbody key={client.id}>
                  <tr>
                    <td>
                      <p>{client.company_name}</p>
                    </td>
                    <td>
                      <button id="e" disabled>
                        Edit client
                      </button>
                    </td>
                    <td>
                      <button
                        id="d"
                        onClick={() => {
                          deleteClient(client.id);
                        }}
                      >
                        Delete client
                      </button>
                    </td>
                  </tr>
                </tbody>

                // <div key={client.id} className={classes.clientList}>
                //   <h2>Company name: {client.company_name}</h2>
                //   <h2>Director: {client.director}</h2>
                //   <h2>Email: {client.email}</h2>
                //   <button
                //     onClick={() => {
                //       deleteClient(client.id);
                //     }}
                //   >
                //     Delete client
                //   </button>
                //   <button disabled>Edit</button>
                // </div>
              );
            })}
          </table>
        </div>
      </div>
    </div>
  );
}

export default Clients;
